import styles from "./HelpStartup.module.scss";

type HelpStartupProps = {
  options: Array<{ label: string; value: string }>;
};

export const HelpStartup = ({ options }: HelpStartupProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.leftSide}>
        <h4 className={styles.title}>JOIN ONZE COMMUNITY</h4>
        <p className={styles.description}>
          ‘Onbeperkte, intensieve en persoonlijke hulp voor jouw startup’
        </p>
      </div>
      <div className={styles.rightSide}>
        <h4 className={styles.title}>VOOR STARTUPS</h4>
        <div className={styles.details}>
          {options.map(({ label, value }) => (
            <div className={styles.item} key={label}>
              <p className={styles.value}>{value}</p>
              <p className={styles.label}>{label}</p>
            </div>
          ))}
        </div>
        <button className={styles.help}>Vraag hulp</button>
      </div>
    </div>
  );
};
